import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { SupportAndHealthServices } from '../../components/support-and-health-services-list-item/support-and-health-services-list-item.component';

@Component({
  templateUrl: './support-and-health-services-dialog.component.html',
  styleUrl: './support-and-health-services-dialog.component.scss',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, NgIf, TranslateModule]
})

export class SupportAndHealthServicesDialog implements OnInit {
  addressString = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: SupportAndHealthServices) {}

  ngOnInit(): void {}
}

